import { Injectable } from '@angular/core'
import { MbProductByOriginalCodeConnector } from '../connectors'

@Injectable({
  providedIn: 'root'
})
export class MbProductByOriginalCodeService {

  constructor (protected productByOriginalCodeConnector: MbProductByOriginalCodeConnector) {
  }

  /** Get product by using the original code (the 130-***-*** number) */
  getProductByOriginalCode (code: string) {
    return this.productByOriginalCodeConnector.getProductByOriginalCode(code)
  }
}
